import { Action } from '@ngrx/store';

import { Customer, CustomerBatchUpload } from 'modules/shared/models/customer.models';
import {
  CustomerResponse, GetCustomerPayload, CreateOrUpdateCustomerPayload, CreateOrUpdateCrpPayload,
  PatchCustomerPayload, GetCustomersBatchUploadsResponse, GetCustomersBatchUploadsDispatchedAction,
  UploadCustomersBatchFileDispatchedAction, GetCurrentDomainDefaultNotifiedUsersPayload,
  SetUserNotificationsPayload
} from '../models/customer.models';
import { GetCrpPayload, GetCrpsPayload } from '../models/crp.models';
import { AccountListResponse } from '../models/admin.models';
import { DocumentResponse } from 'store/models/document.models';
import { RiskReportComments } from 'modules/shared/models/risk-assessment.models';
import { Crp } from 'modules/shared/models/crp.models';
import { CrpResponse } from 'store/models/crp.models';

export enum CustomerActionTypes {
  GET_CUSTOMER = 'GET_CUSTOMER',
  GET_CUSTOMER_SUCCESS = 'GET_CUSTOMER_SUCCESS',
  GET_CUSTOMER_FAILURE = 'GET_CUSTOMER_FAILURE',
  RESET_CUSTOMER_OVERVIEW = 'RESET_CUSTOMER_OVERVIEW',
  GET_CUSTOMERS = 'GET_CUSTOMERS',
  GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS',
  GET_CUSTOMERS_FAILURE = 'GET_CUSTOMERS_FAILURE',
  GET_CUSTOMER_STATUS = 'GET_CUSTOMER_STATUS',
  GET_CUSTOMER_STATUS_SUCCESS = 'GET_CUSTOMER_STATUS_SUCCESS',
  GET_CUSTOMER_STATUS_FAILURE = 'GET_CUSTOMER_STATUS_FAILURE',
  GET_RECORD = 'GET_RECORD',
  GET_RECORD_SUCCESS = 'GET_RECORD_SUCCESS',
  GET_RECORD_FAILURE = 'GET_RECORD_FAILURE',
  GET_CRP = 'GET_CRP',
  GET_CRP_SUCCESS = 'GET_CRP_SUCCESS',
  GET_CRP_FAILURE = 'GET_CRP_FAILURE',
  UPDATE_CRP_SCREENING = 'UPDATE_CRP_SCREENING',
  GET_CRPS = 'GET_CRPS',
  GET_CRPS_SUCCESS = 'GET_CRPS_SUCCESS',
  GET_CRPS_FAILURE = 'GET_CRPS_FAILURE',
  GET_CRPS_NO_PRIMARY = 'GET_CRPS_NO_PRIMARY',
  GET_CRPS_NO_PRIMARY_SUCCESS = 'GET_CRPS_NO_PRIMARY_SUCCESS',
  GET_CRPS_NO_PRIMARY_FAILURE = 'GET_CRPS_NO_PRIMARY_FAILURE',
  GET_CUSTOMER_DOCUMENTS = 'GET_CUSTOMER_DOCUMENTS',
  GET_CUSTOMER_DOCUMENTS_SUCCESS = 'GET_CUSTOMER_DOCUMENTS_SUCCESS',
  GET_CUSTOMER_DOCUMENTS_FAILURE = 'GET_CUSTOMER_DOCUMENTS_FAILURE',
  GET_REPORT_COMMENTS = 'GET_REPORT_COMMENTS',
  GET_REPORT_COMMENTS_SUCCESS = 'GET_REPORT_COMMENTS_SUCCESS',
  GET_REPORT_COMMENTS_FAILURE = 'GET_REPORT_COMMENTS_FAILURE',
  GET_OCR_COMPARE_RESULTS = 'GET_OCR_COMPARE_RESULTS',
  GET_OCR_COMPARE_RESULTS_SUCCESS = 'GET_OCR_COMPARE_RESULTS_SUCCESS',
  GET_OCR_COMPARE_RESULTS_FAILURE = 'GET_OCR_COMPARE_RESULTS_FAILURE',
  GET_VERIFICATION_CONCLUSIONS = 'GET_VERIFICATION_CONCLUSIONS',
  GET_VERIFICATION_CONCLUSIONS_SUCCESS = 'GET_VERIFICATION_CONCLUSIONS_SUCCESS',
  GET_VERIFICATION_CONCLUSIONS_FAILURE = 'GET_VERIFICATION_CONCLUSIONS_FAILURE',
  UPDATE_VERIFICATION_CONCLUSIONS = 'UPDATE_VERIFICATION_CONCLUSIONS',
  UPDATE_VERIFICATION_CONCLUSIONS_SUCCESS = 'UPDATE_VERIFICATION_CONCLUSIONS_SUCCESS',
  UPDATE_VERIFICATION_CONCLUSIONS_FAILURE = 'UPDATE_VERIFICATION_CONCLUSIONS_FAILURE',
  GET_USERS = 'GET_USERS',
  GET_USERS_SUCCESS = 'GET_USERS_SUCCESS',
  GET_USERS_FAILURE = 'GET_USERS_FAILURE',
  GET_SEARCH_USERS = 'GET_USERS',
  GET_SEARCH_USERS_SUCCESS = 'GET_SEARCH_USERS_SUCCESS',
  GET_SEARCH_USERS_FAILURE = 'GET_SEARCH_USERS_FAILURE',
  CREATE_DRAFT_CUSTOMER = 'CREATE_DRAFT_CUSTOMER',
  CREATE_AND_RA_CUSTOMER = 'CREATE_AND_RA_CUSTOMER',
  CREATE_AND_CRP_CUSTOMER = 'CREATE_AND_CRP_CUSTOMER',
  GET_DEFAULT_NOTIFIED_USERS = 'GET_DEFAULT_NOTIFIED_USERS',
  GET_DEFAULT_NOTIFIED_USERS_SUCCESS = 'GET_DEFAULT_NOTIFIED_USERS_SUCCESS',
  GET_DEFAULT_NOTIFIED_USERS_FAILURE = 'GET_DEFAULT_NOTIFIED_USERS_FAILURE',
  SET_DEFAULT_NOTIFIED_USERS = 'SET_DEFAULT_NOTIFIED_USERS',
  SET_DEFAULT_NOTIFIED_USERS_SUCCESS = 'SET_DEFAULT_NOTIFIED_USERS_SUCCESS',
  SET_DEFAULT_NOTIFIED_USERS_FAILURE = 'SET_DEFAULT_NOTIFIED_USERS_FAILURE',
  REGISTER_CUSTOMER_CRP = 'REGISTER_CUSTOMER_CRP',
  REGISTER_CUSTOMER_CRP_SUCCESS = 'REGISTER_CUSTOMER_CRP_SUCCESS',
  REGISTER_CUSTOMER_CRP_FAILURE = 'REGISTER_CUSTOMER_CRP_FAILURE',
  CREATE_OR_UPDATE_CUSTOMER = 'CREATE_OR_UPDATE_CUSTOMER',
  CREATE_OR_UPDATE_CUSTOMER_SUCCESS = 'CREATE_OR_UPDATE_CUSTOMER_SUCCESS',
  CREATE_OR_UPDATE_CUSTOMER_FAILURE = 'CREATE_OR_UPDATE_CUSTOMER_FAILURE',
  CREATE_OR_UPDATE_CRP = 'CREATE_OR_UPDATE_CRP',
  CREATE_OR_UPDATE_CRP_SUCCESS = 'CREATE_OR_UPDATE_CRP_SUCCESS',
  CREATE_OR_UPDATE_CRP_FAILURE = 'CREATE_OR_UPDATE_CRP_FAILURE',
  CREATE_AND_RA_CRP = 'CREATE_AND_RA_CRP',
  CREATE_AND_ADD_CRP = 'CREATE_AND_ADD_CRP',
  UPDATE_AND_RA_CRP = 'UPDATE_AND_RA_CRP',
  UPDATE_AND_ADD_CRP = 'UPDATE_AND_ADD_CRP',
  RELOAD_CRP_LIST = 'RELOAD_CRP_LIST',
  PATCH_CUSTOMER = 'PATCH_CUSTOMER',
  PATCH_CUSTOMER_SUCCESS = 'PATCH_CUSTOMER_SUCCESS',
  PATCH_CUSTOMER_FAILURE = 'PATCH_CUSTOMER_FAILURE',
  // Customers Get Batch Uploads
  GET_CUSTOMERS_BATCH_UPLOADS_LIST = 'GET_CUSTOMERS_BATCH_UPLOADS_LIST',
  GET_CUSTOMERS_BATCH_UPLOADS_LIST_SUCCESS = 'GET_CUSTOMERS_BATCH_UPLOADS_LIST_SUCCESS',
  GET_CUSTOMERS_BATCH_UPLOADS_LIST_FAILURE = 'GET_CUSTOMERS_BATCH_UPLOADS_LIST_FAILURE',
  CLEAR_GET_CUSTOMERS_BATCH_UPLOADS_LIST = 'CLEAR_GET_CUSTOMERS_BATCH_UPLOADS_LIST',
  // Customers Batch Upload
  UPLOAD_CUSTOMERS_BATCH_FILE = 'UPLOAD_CUSTOMERS_BATCH_FILE',
  UPLOAD_CUSTOMERS_BATCH_FILE_SUCCESS = 'UPLOAD_CUSTOMERS_BATCH_FILE_SUCCESS',
  UPLOAD_CUSTOMERS_BATCH_FILE_FAILURE = 'UPLOAD_CUSTOMERS_BATCH_FILE_FAILURE',
  // Clear errors global
  CLEAR_ERRORS = 'CLEAR_ERRORS',
}

export class GetCustomersSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMERS_SUCCESS;
  constructor(public payload: CustomerResponse = null) { }
}

export class GetCustomersFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMERS_FAILURE;
  constructor(public payload: CustomerResponse = null) { }
}

export class GetCustomer implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMER;
  constructor(public payload?: GetCustomerPayload) { }
}

export class GetCustomerSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMER_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetCustomerFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMER_FAILURE;
  constructor(public payload: any = null) { }
}
export class GetCustomerStatus implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMER_STATUS;
  constructor(public payload?: GetCustomerPayload) { }
}

export class GetCustomerStatusSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMER_STATUS_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetCustomerStatusFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMER_STATUS_FAILURE;
  constructor(public payload: any = null) { }
}
export class GetRecord implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_RECORD;
  constructor(public payload?: any) { }
}

export class GetRecordSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_RECORD_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetRecordFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_RECORD_FAILURE;
  constructor(public payload: any = null) { }
}

export class ResetCustomerOverview implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.RESET_CUSTOMER_OVERVIEW;
  constructor(public payload: any = null) { }
}

export class GetCustomers implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMERS;
  constructor(public payload?: any) { }
}

export class GetCrp implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CRP;
  constructor(public payload?: GetCrpPayload) { }
}

export class GetCrpSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CRP_SUCCESS;
  constructor(public payload: Crp = null) { }
}

export class GetCrpFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CRP_FAILURE;
  constructor(public payload: any = null) { }
}

export class UpdateCrpScreening implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.UPDATE_CRP_SCREENING;
  constructor(public payload: any = null) { }
}

export class GetCrps implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CRPS;
  constructor(public payload?: GetCrpsPayload) { }
}

export class GetCrpsSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CRPS_SUCCESS;
  constructor(public payload: CrpResponse = null) { }
}

export class GetCrpsFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CRPS_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetCrpsWithoutPrimary implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CRPS_NO_PRIMARY;
  constructor(public payload?: any) { }
}

export class GetCrpsWithoutPrimarySuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CRPS_NO_PRIMARY_SUCCESS;
  constructor(public payload?: any) { }
}

export class GetCrpsWithoutPrimaryFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CRPS_NO_PRIMARY_FAILURE;
  constructor(public payload?: any) { }
}

export class GetCustomerDocuments implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMER_DOCUMENTS;
  constructor(public payload?: any) { }
}

export class GetCustomerDocumentsSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMER_DOCUMENTS_SUCCESS;
  constructor(public payload: DocumentResponse = null) { }
}

export class GetCustomerDocumentsFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMER_DOCUMENTS_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetReportComments implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_REPORT_COMMENTS;
  constructor(public payload?: any) { }
}

export class GetReportCommentsSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_REPORT_COMMENTS_SUCCESS;
  constructor(public payload: RiskReportComments = null) { }
}

export class GetReportCommentsFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_REPORT_COMMENTS_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetUsersSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_USERS_SUCCESS;
  constructor(public payload: AccountListResponse = null) { }
}

export class GetUsersFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_USERS_FAILURE;
  constructor(public payload: AccountListResponse = null) { }
}

export class GetUsers implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_USERS;
  constructor(public payload?: any) { }
}

export class GetDefaultNotifiedUsersSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_DEFAULT_NOTIFIED_USERS_SUCCESS;
  constructor(public payload?: any) { }
}

export class GetDefaultNotifiedUsersFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_DEFAULT_NOTIFIED_USERS_FAILURE;
  constructor(public payload: string) { }
}

export class GetDefaultNotifiedUsers implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_DEFAULT_NOTIFIED_USERS;
  constructor(public payload?: GetCurrentDomainDefaultNotifiedUsersPayload) { }
}

export class SetDefaultNotifiedUsersSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.SET_DEFAULT_NOTIFIED_USERS_SUCCESS;
  constructor(public payload?: any) { }
}

export class SetDefaultNotifiedUsersFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.SET_DEFAULT_NOTIFIED_USERS_FAILURE;
  constructor(public payload: string) { }
}

export class SetDefaultNotifiedUsers implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.SET_DEFAULT_NOTIFIED_USERS;
  constructor(public payload?: SetUserNotificationsPayload) { }
}

export class ReloadCrpList implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.RELOAD_CRP_LIST;
  constructor(public payload?: any) { }
}

export class CreateDraftCustomer implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.CREATE_DRAFT_CUSTOMER;
  constructor(public payload: CreateOrUpdateCustomerPayload = null) { }
}
export class CreateAndRACustomer implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.CREATE_AND_RA_CUSTOMER;
  constructor(public payload: CreateOrUpdateCustomerPayload = null) { }
}
export class CreateAndCRPCustomer implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.CREATE_AND_CRP_CUSTOMER;
  constructor(public payload: CreateOrUpdateCustomerPayload = null) { }
}
export class CreateOrUpdateCustomer implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER;
  constructor(public payload: CreateOrUpdateCustomerPayload = null) { }
}
export class CreateOrUpdateCustomerSuccess implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER_SUCCESS;
  constructor(public payload: Customer = null) { }
}
export class CreateOrUpdateCustomerFailure implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER_FAILURE;
  constructor(public payload: any = null) { }
}

export class CreateOrUpdateCrp implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.CREATE_OR_UPDATE_CRP;
  constructor(public payload: CreateOrUpdateCrpPayload = null) { }
}

export class CreateOrUpdateCrpSuccess implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.CREATE_OR_UPDATE_CRP_SUCCESS;
  constructor(public payload: Crp = null) { }
}

export class CreateOrUpdateCrpFailure implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.CREATE_OR_UPDATE_CRP_FAILURE;
  constructor(public payload: any = null) { }
}

export class CreateAndRACrp implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.CREATE_AND_RA_CRP;
  constructor(public payload: CreateOrUpdateCrpPayload = null) { }
}

export class CreateAndAddCrp implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.CREATE_AND_ADD_CRP;
  constructor(public payload: CreateOrUpdateCrpPayload = null) { }
}

export class UpdateAndRACrp implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.UPDATE_AND_RA_CRP;
  constructor(public payload: CreateOrUpdateCrpPayload = null) { }
}
export class UpdateAndAddCrp implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.UPDATE_AND_ADD_CRP;
  constructor(public payload: CreateOrUpdateCrpPayload = null) { }
}

export class PatchCustomer implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.PATCH_CUSTOMER;
  constructor(public payload: PatchCustomerPayload = null) { }
}
export class PatchCustomerSuccess implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.PATCH_CUSTOMER_SUCCESS;
  constructor(public payload: Customer = null) { }
}
export class PatchCustomerFailure implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.PATCH_CUSTOMER_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetCustomersBatchUploadsList implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST;
  constructor(public payload: GetCustomersBatchUploadsDispatchedAction['payload'] = null) { }
}
export class GetCustomersBatchUploadsListSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST_SUCCESS;
  constructor(public payload: GetCustomersBatchUploadsResponse = null) { }
}
export class GetCustomersBatchUploadsListFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST_FAILURE;
  constructor(public payload: any = null) { }
}
export class ClearCustomersBatchUploadsList implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.CLEAR_GET_CUSTOMERS_BATCH_UPLOADS_LIST;
  constructor(public payload: any = null) { }
}

export class UploadCustomersBatchFile implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.UPLOAD_CUSTOMERS_BATCH_FILE;
  constructor(public payload: UploadCustomersBatchFileDispatchedAction['payload'] = null) { }
}
export class UploadCustomersBatchFileSuccess implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.UPLOAD_CUSTOMERS_BATCH_FILE_SUCCESS;
  constructor(public payload: CustomerBatchUpload = null) { }
}
export class UploadCustomersBatchFileFailure implements Action {
  readonly type: CustomerActionTypes = CustomerActionTypes.UPLOAD_CUSTOMERS_BATCH_FILE_FAILURE;
  constructor(public payload: any = null) { }
}

export class ClearErrors implements Action {
  readonly type: CustomerActionTypes =
    CustomerActionTypes.CLEAR_ERRORS;
  constructor(public payload: any = null) { }
}

export type CustomerActions =
  | GetCustomer
  | GetCustomerSuccess
  | GetCustomerFailure
  | GetCustomerStatus
  | GetCustomerStatusSuccess
  | GetCustomerStatusFailure
  | ResetCustomerOverview
  | GetCustomers
  | GetCustomersSuccess
  | GetCustomersFailure
  | GetCrp
  | GetRecord
  | GetRecordSuccess
  | GetRecordFailure
  | GetCrpSuccess
  | GetCrpFailure
  | UpdateCrpScreening
  | GetCrps
  | GetCrpsSuccess
  | GetCrpsFailure
  | GetCrpsWithoutPrimary
  | GetCrpsWithoutPrimarySuccess
  | GetCrpsWithoutPrimaryFailure
  | GetCustomerDocuments
  | GetCustomerDocumentsSuccess
  | GetCustomerDocumentsFailure
  | GetReportComments
  | GetReportCommentsSuccess
  | GetReportCommentsFailure
  | GetUsers
  | GetUsersSuccess
  | GetUsersFailure
  | SetDefaultNotifiedUsers
  | SetDefaultNotifiedUsersSuccess
  | SetDefaultNotifiedUsersFailure
  | CreateOrUpdateCustomer
  | CreateOrUpdateCustomerSuccess
  | CreateOrUpdateCustomerFailure
  | CreateOrUpdateCrp
  | CreateOrUpdateCrpSuccess
  | CreateOrUpdateCrpFailure
  | ReloadCrpList
  | PatchCustomer
  | PatchCustomerSuccess
  | PatchCustomerFailure
  | GetCustomersBatchUploadsList
  | GetCustomersBatchUploadsListSuccess
  | GetCustomersBatchUploadsListFailure
  | ClearCustomersBatchUploadsList
  | UploadCustomersBatchFile
  | UploadCustomersBatchFileSuccess
  | UploadCustomersBatchFileFailure
  | ClearErrors;
